import React, { ReactElement } from 'react';
import { Discourse } from '../containers/discourse';
import { APP_CFG } from '../appcfg';
import { PageContent } from './page-content';
import {
  PageType,
  DiscourseData,
  DiscourseFixedData,
  PageDataParams,
  SFFProblemType
} from 'its-pages';

export class DiscourseContent extends PageContent {
  public get component(): ReactElement {
    return <Discourse content={this} key={this.pageData.seed} />;
  }

  public get pageType(): PageType {
    return PageType.Problem;
  }

  public getSecondTryHint(): JSX.Element {
    return (
      <div>
        <p>
          Not Quite. Either what you have selected is incorrect or you missed
          other correct responses. Review your answers and try again.
        </p>
      </div>
    );
  }

  private logAnswers(): void {
    const pageData = this.pageData as DiscourseFixedData;
    const hasFixed = pageData.type === SFFProblemType.DiscourseFixed;

    if (APP_CFG.log) {
      pageData.annotations.forEach((element): void => {
        const {
          tag,
          anchor,
          anchor: {
            path: [contentIndex, childIndex]
          },
          focus
        } = element;
        const line = pageData.content[contentIndex];
        const text = line.children[childIndex].text.substring(
          anchor.offset,
          focus.offset
        );
        const answer = pageData.tags[tag].reason.declarative;

        APP_CFG.consoleLog(text + '\n\t' + answer);
      });

      if (hasFixed) {
        APP_CFG.consoleLog(`${pageData.answer} is correct fixed response`);
      }
    }
  }

  public constructor(params: PageDataParams) {
    const PageDataType =
      params.rawPageData.type === SFFProblemType.Discourse
        ? DiscourseData
        : DiscourseFixedData;
    super(new PageDataType(params));

    this.logAnswers();
  }
}
